import { accordionAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
  SystemStyleObject,
} from '@chakra-ui/react';
import {
  getBoxSizingStyles,
  getFontWeightToken,
  getTypographyToken,
} from '@allergan-data-labs/alle-elements-core';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

export const getAccordionIconMargins = (): SystemStyleObject => {
  return {
    width: '24px',
    height: '24px',
    mr: '0.5rem',
    '& svg': {
      width: '24px',
      height: '24px',
    },
  };
};

export const getAccordionTransparentBorderColor = () => 'transparent';

export const getContentTitleStyles = (): SystemStyleObject => {
  return {
    ...getTypographyToken('Body/Medium/Medium'),
    fontWeight: 'Semibold',
    paddingBottom: '0.5rem',
  };
};

const baseStyleContainer = defineStyle((props) => {
  const { colorScheme: c } = props;
  return {
    ...getBoxSizingStyles(),
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    bg: `${c}.Container/Neutral/Base`,
    color: `${c}.Text/Neutral/Interactive/Enable`,
    borderColor: `${c}.Border/Brand/Subtle 3`,
    _first: {
      borderTopWidth: 0,
    },
  };
});

const baseStyleButton = defineStyle((props) => {
  const { colorScheme: c } = props;
  return {
    ...getBoxSizingStyles(),
    ...getTypographyToken('Body/Medium/Medium'),
    cursor: 'pointer',
    fontWeight: 'Semibold',
    color: `${c}.Text/Neutral/Interactive/Enable`,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    bg: `${c}.Container/Neutral/Base`,
    p: '1rem',
    _focusVisible: {
      color: `${c}.Text/Neutral/Interactive/Hover`,
      boxShadow: 'none',
      outlineStyle: 'solid',
      outlineColor: `${c}.Border/Brand/Focus ring/Default`,
      outlineWidth: '0.25rem',
      outlineOffset: '0.0625rem',
    },
    _hover: {
      color: `${c}.Text/Neutral/Interactive/Hover`,
      bg: `${c}.Container/Neutral/Base`,
    },
    _active: {
      color: `${c}.Text/Neutral/Interactive/Pressed`,
    },
  };
});

const baseStylePanel = defineStyle({
  ...getTypographyToken('Body/Medium/Medium'),
  pb: '2.25rem',
  px: '1rem',
});

const baseStyleIcon = defineStyle({
  width: '24px',
  height: '24px',
  mx: '1rem',
});

const baseStyle = definePartsStyle((props) => {
  return {
    container: baseStyleContainer(props),
    button: baseStyleButton(props),
    panel: baseStylePanel,
    icon: baseStyleIcon,
  };
});

export const getAccordionPanelStyles = (): SystemStyleObject => {
  return {
    fontWeight: getFontWeightToken('Regular'),
  };
};

export const AccordionTheme = defineMultiStyleConfig({
  baseStyle,
});
